import * as Types from '../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type CreateMagicLinkLoginMutationVariables = Types.Exact<{
  input: Types.CreateMagicLinkLoginInput
}>

export type CreateMagicLinkLoginMutation = {
  __typename?: 'Mutation'
  createMagicLinkLogin?: {
    __typename?: 'CreateMagicLinkLoginPayload'
    success: boolean
    expiresInMinutes?: number | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const CreateMagicLinkLoginDocument = `
    mutation CreateMagicLinkLogin($input: CreateMagicLinkLoginInput!) {
  createMagicLinkLogin(input: $input) {
    success
    expiresInMinutes
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useCreateMagicLinkLoginMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    CreateMagicLinkLoginMutation,
    TError,
    CreateMagicLinkLoginMutationVariables,
    TContext
  >
) =>
  useMutation<CreateMagicLinkLoginMutation, TError, CreateMagicLinkLoginMutationVariables, TContext>(
    ['CreateMagicLinkLogin'],
    (variables?: CreateMagicLinkLoginMutationVariables) =>
      fetchGql<CreateMagicLinkLoginMutation, CreateMagicLinkLoginMutationVariables>(
        CreateMagicLinkLoginDocument,
        variables
      )(),
    options
  )
